// extracted by mini-css-extract-plugin
export default {"checkbox":"CWarsCalendarDialog_checkbox_ed7fe"};